module.exports = "/assets/connect/fonts/BrenntagSans-Regular.woff2";